import { MatIconModule } from '@angular/material/icon';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LocalStorage } from 'ngx-store';
import { JwtHelperService } from '@auth0/angular-jwt';
import { FullScreenService } from 'src/app/service/fullscreen.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  active: string = ""
  @LocalStorage('loggedUser') loggedUser: any;
  @LocalStorage('userData') userData: any;
  @LocalStorage('isAlsoAdmin') isAlsoAdmin: boolean;


  lan = localStorage.getItem("lan")

  isLogged: boolean;
  isAdmin: boolean; //old

//   language = {
//     "en": "English",
//     "it": "Italian",
//     "pt": "Portuguese",
//     "es": "Español",
//     "fr": "Français",
//     "el": "Greek",
//     "sq": "Albanian",
//     "ru": "Russian",
//     "hi": "Hindi",
//     "zh": "Chinese",
//     "ar": "Arabic",
//     "bn": "Bengali",
//     "ur": "Urdu",
//     "ko": "Korean",
//     "id": "Indonesian",
//     "mr": "Marathi",
//     "tr": "Turkish",
//     "vi": "Vietnamese",
//     "pa": "Punjabi",
//     "ja": "Japanese"
// }
  language = {
    "en": "English",
    "it": "Italian",
    "pt": "Portuguese",
    "es": "Español",
    "fr": "Français",
    "el": "Greek",
    "hi": "Hindi",
}

// languages = [
//     {"full": "English", "abb": "en"},
//     {"full": "Italian", "abb": "it"},
//     {"full": "Portuguese", "abb": "pt"},
//     {"full": "Español", "abb": "es"},
//     {"full": "Français", "abb": "fr"},
//     {"full": "Greek", "abb": "el"},
//     {"full": "Hindi", "abb": "hi"},
//     {"full": "Chinese", "abb": "zh"},
//     {"full": "Arabic", "abb": "ar"},
//     {"full": "Bengali", "abb": "bn"},
//     {"full": "Urdu", "abb": "ur"},
//     {"full": "Korean", "abb": "ko"},
//     {"full": "Indonesian", "abb": "id"},
//     {"full": "Marathi", "abb": "mr"},
//     {"full": "Turkish", "abb": "tr"},
//     {"full": "Vietnamese", "abb": "vi"},
//     {"full": "Punjabi", "abb": "pa"},
//     {"full": "Japanese", "abb": "ja"}
// ]
languages = [
  {"full": "English", "abb": "en"},
  {"full": "Italian", "abb": "it"},
  {"full": "Portuguese", "abb": "pt"},
  {"full": "Español", "abb": "es"},
  {"full": "Français", "abb": "fr"},
  {"full": "Greek", "abb": "el"},
  {"full": "Hindi", "abb": "hi"},
]
  
  hide = false
  settedLanguage;


  constructor(private router: Router,
    public fullScreenService: FullScreenService,
    public translate: TranslateService,
    public icon: MatIconModule,
    private userService: UserService) {
    router.events.subscribe(route => {
      if (route instanceof NavigationEnd) {
        this.isLogged = (this.loggedUser) && (this.userData);
        this.isAdmin = false
        const helper = new JwtHelperService();
        if (this.loggedUser && this.loggedUser.access_token) {
          const user = helper.decodeToken(this.loggedUser.access_token);
          if (user.role && user.role == "admin") this.isAdmin = true
        }
      }
    });

    //used to hide navbar when full screen is needed
    fullScreenService.fullScreenObs.subscribe((fullScreen) => {
      this.hide = fullScreen
    })

    // This is to show all the languages except the one already setted
    const indexLanguageToRemove = this.languages.findIndex((language)=>{
      return language.abb === this.lan;
    })
    if(indexLanguageToRemove !==-1){
      this.languages.splice(indexLanguageToRemove,1)
    }

  }


  ngOnInit() {}
  

  logOn() {
    this.router.navigate(['/logon']);
  }

  setLanguage(value) {
    localStorage.setItem("lan", value)
    this.lan = value
    window.location.reload();
  }

  goToAdminArea() {
    this.router.navigate(['/admin-area']);

  }

  logOut() {
    const lan = localStorage.getItem('lan')
    localStorage.clear();
    localStorage.setItem('lan', lan)
    this.userData = undefined
    this.loggedUser = undefined
    window.location.href = '/logon';

  }

  register() {
    this.router.navigate(['/register']);
  }

  goback() {

    window.location.href = '/';
  }

  adminArea() {
    window.location.href = '/admin-area'
  }

}
